import { useEffect, useState } from "react";
import CustomSelectSimple from "./CustomSelectSimple";

const currentYear = new Date().getFullYear();
const godine = Array.from({ length: 30 }, (_, i) => currentYear - 10 + i);
// const dani = Array.from({ length: 30 }, (_, i) =>
//   i + 1 < 10 ? `0${i + 1}` : i + 1
// );
const meseci = Array.from({ length: 12 }, (_, i) =>
  i + 1 < 10 ? `0${i + 1}` : i + 1
);

const mesecDani = {
  "01": 31,
  "02": 28,
  "03": 31,
  "04": 30,
  "05": 31,
  "06": 30,
  "07": 31,
  "08": 31,
  "09": 30,
  10: 31,
  11: 30,
  12: 31
};
function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
function getDaysNumber(mesec, godina) {
  return mesec !== "02"
    ? mesecDani[mesec]
    : isLeapYear(Number(godina))
      ? 29
      : 28;
}

// selectedValue in format: "26.01.02"
const DateSelect = ({ label, selectedValue, onSelectChange }) => {
  const [godina, setGodina] = useState("");
  const [mesec, setMesec] = useState("");
  const [dan, setDan] = useState("");

  const [dani, setDani] = useState(
    Array.from({ length: 30 }, (_, i) => (i + 1 < 10 ? `0${i + 1}` : i + 1))
  );

  useEffect(() => {
    if (!mesec) return;

    const numOfDays = getDaysNumber(mesec, godina);
    setDani(
      Array.from({ length: numOfDays }, (_, i) =>
        i + 1 < 10 ? `0${i + 1}` : i + 1
      )
    );

    if (Number(dan) > numOfDays) changeDan(String(numOfDays));
  }, [mesec, godina]);

  useEffect(() => {
    if (!selectedValue) return;

    const dateParts = selectedValue.split(".");
    const god = !dateParts[0]
      ? ""
      : dateParts[0].length === 2
        ? `20${dateParts[0]}`
        : dateParts[0];
    setGodina(god);
    setMesec(dateParts[1] || "");
    setDan(dateParts[2] || "");
  }, [selectedValue]);

  const changeGodina = (newValue) => {
    setGodina(newValue);
    onSelectChange(`${newValue.toString().slice(-2)}.${mesec}.${dan}`);
  };
  const changeMesec = (newValue) => {
    setMesec(newValue);
    onSelectChange(`${godina.toString().slice(-2)}.${newValue}.${dan}`);
  };
  const changeDan = (newValue) => {
    setDan(newValue);
    onSelectChange(`${godina.toString().slice(-2)}.${mesec}.${newValue}`);
  };

  return (
    <div>
      <div
        style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
      >
        {label}
      </div>
      <div style={{ display: "flex", gap: "3px" }}>
        <div style={{ width: "80px" }}>
          <CustomSelectSimple
            allValues={godine}
            selectedValue={godina}
            onSelectChange={changeGodina}
          />
        </div>
        <div style={{ width: "120px" }}>
          <CustomSelectSimple
            allValues={meseci}
            selectedValue={mesec}
            onSelectChange={changeMesec}
            isMeseci={true}
          />
        </div>
        <div style={{ width: "60px" }}>
          <CustomSelectSimple
            allValues={dani}
            selectedValue={dan}
            onSelectChange={changeDan}
          />
        </div>
      </div>
    </div>
  );
};

export default DateSelect;
